import React from 'react';
import type { LinkProps } from './Link.types';
import { StyledLink, StyledSpan } from './styles';
import { useUniversalComponents } from '../../../utils/useUniversalComponents';
export const Link = ({ children, to, ...props }: LinkProps) => {
  const fixScroll = () => {
    document.body.style.overflow = 'auto';
  };

  const { Link, isUsingNext } = useUniversalComponents();

  if (isUsingNext) {
    return (
      <Link href={to} legacyBehavior passHref>
        <StyledLink
          onClick={fixScroll}
          style={{ textDecoration: 'none' }}
          {...props}>
          {children}
        </StyledLink>
      </Link>
    );
  }

  return (
    <Link href={to} style={{ textDecoration: 'none' }}>
      <StyledSpan onClick={fixScroll} {...props}>
        {children}
      </StyledSpan>
    </Link>
  );
};
